import React from "react";
import { Link } from "react-router-dom";
import logo from '../../assets/logoblack.png'
import amigos from "../../assets/contenido/amigos.png";





export default function ReglamentoEscritores() {
  return (
    <div className="contenedor_joinus">
       <nav className="navbar navbar-light mb-5" id="encabezado">
                <Link to="/" className="container-fluid">
                    <img
                    src={logo}
                    width="290"
                    height="550"
                    className="img-fluid d-block mx-auto"
                    alt='logoMingga'
                    />
                </Link>
            </nav>

            <div className="container-fluid">
            <div className="privacy" align="left" id="padding">
              <h3 align="center">ACUERDO 03 DE 2025<br /></h3>
                <h5 align="center"> <b>REGLAMENTO DEL PROGRAMA ESCRITORES LEO</b></h5>
                <br />
                <p>
                <b> Artículo 1.</b>  El <b> Programa Escritores LEO</b>  como servicio del Club Mundial de
                Lectura para sus socios, se regirá por el presente Reglamento.
                </p>
                <h6 align="center"> <b>CAPITULO I</b></h6>
                <h6 align="center"> <b>OBJETIVOS Y MEDIOS</b></h6>
                <p> 
                <b>Artículo 2. - Definición.</b> El programa <b>Escritores LEO</b> es un servicio gratuito que
                el <b>Club Mundial de Lectura</b> ofrece a sus socios, para que puedan publicar y
                difundir las obras de su autoría, entre los miembros de la comunidad LEO a nivel
                local, nacional y mundial, a través de internet.  <br />
                El Programa Escritores LEO está organizado como una red social con cobertura
                mundial, que permite la creación de grupos y comunidades, los contactos y el
                trabajo colaborativo de los socios de acuerdo con sus intereses literarios.              </p>
                <p> 
                <b> Artículo 3. - Objetivos. </b> 
                1. Promover la escritura como hábito que permite expresar las ideas y contribuir
                con las nuevas obras a la expansión del conocimiento y el patrimonio literario
                nacional y universal. <br />
                2. Fortalecer las competencias comunicativas de los socios, para que puedan
                generar contenidos efectivos que mejoren su desempeño en los escenarios
                académico, social, laboral y de la comunidad global integrada por internet. <br />
                3. Ofrecer un escenario web en el que los socios puedan publicar las obras de su
                autoría para que sean conocidas por la Comunidad Leo a nivel mundial. <br />
                4. Facilitar la creación y operación de grupos y comunidades temáticas sobre las
                diferentes áreas del conocimiento y géneros literarios. <br />
                5. Facilitar el conocimiento y la integración a nivel mundial de los socios LEO,
                alrededor de los temas del conocimiento y la creación literaria. <br />
                6. Facilitar a los socios que tengan obras comerciales de su autoría, que puedan
                publicar y promover dichas obras entre los socios de la Comunidad LEO.


                </p>
                <p>
                <b> Artículo 4.- Principios Básicos.</b>  El programa Escritores LEO se rige por los
                siguientes principios:  <br />
                1. Pueden publicar obras los socios LEO que libre y voluntariamente decidan
                utilizar el servicio.  <br />
                2. Las obras deberán ser de autoría del respectivo socio, quien al publicarlas
                garantiza el pleno cumplimiento de la normatividad legal sobre derechos de autor.  <br />
                3. Las obras pueden versar sobre cualquier área del conocimiento o género
                literario.  <br />
                4. No hay límites en la extensión de las obras.  <br />
                5. Al publicar sus obras, el respectivo socio autoriza a los miembros de la
                comunidad LEO a su lectura y enviar posibles comentarios.  <br />
                6. El respectivo socio podrá modificar o retirar las obras publicadas en cualquier
                momento.  <br />
                7. LEO podrá retirar obras que infrinjan las normas legales sobre derechos de
                autor, que sean contrarias a la moral pública o contengan manifestaciones
                injuriosas, de odio, racismo, sexismo, xenofobia o cualquier otra forma violatoria
                de los derechos humanos.
                </p>
                
                <p>
                <b>Artículo 5. Vigencia.</b> El presente Acuerdo rige a partir de la fecha.
                </p>
                <p>
                <b>Artículo 6. Aprobación.</b> - Reglameno aprobado en la sesión conjunta de la Editorial Educativa Bibliocol SAS y la Asociación Leo Club Mundial de Lectura realizada el 4 de agosto de 2025.
                </p>
                

                <h6 align="center"><b>DIANA MARCELA ROMERO ROJAS</b><br /></h6>
                <p align="center"> Directora del Programa <br />
                   </p> 
            

          
          

                




        






            </div>
            </div>
              
     <br />


              
             
    </div>
  );
}
